import { Text } from '@wix/design-system';
import { SparkleIcon } from '@wix/package-picker-shared-eclipse';
import classNames from 'classnames';
import React from 'react';
import { DATA_HOOKS } from './constants';
import s from './AiPlanRecommendationCard.scss';

export type AiBannerSlot = 'top' | 'hat';

interface AiPlanRecommendationBannerProps {
  title: string;
  ariaLabel?: string;
  placement: AiBannerSlot;
  isDummy?: boolean;
}

export const AiPlanRecommendationBanner = ({
  title,
  ariaLabel,
  placement,
  isDummy = false,
}: AiPlanRecommendationBannerProps) => (
  <div
    className={classNames(s.banner, {
      [s.bannerFullBleed]: placement === 'top' && !isDummy,
      [s.bannerDummy]: isDummy,
      [s.bannerDummyTop]: placement === 'top' && isDummy,
    })}
    data-hook={isDummy ? DATA_HOOKS.bannerDummy : DATA_HOOKS.banner}
    role={isDummy ? undefined : 'region'}
    aria-label={isDummy ? undefined : ariaLabel}
    aria-hidden={isDummy || undefined}
  >
    <div className={s.bannerContent}>
      <SparkleIcon svgClassName={s.bannerSparkle} />
      <Text
        size="small"
        weight="bold"
        className={s.bannerText}
        dataHook={isDummy ? undefined : DATA_HOOKS.title}
      >
        {title}
      </Text>
    </div>
  </div>
);
